<div class="page404">
    <h1>404</h1>
    <h5>Not Found</h5>
    <p>
        the resource requested could not be found on this server
    </p>
</div>